import { useState, useEffect, useCallback } from "react";
import { Row, Col } from "antd";
import { useNavigate } from "react-router-dom";

function Mention({
  heading = "Join the Circle",
  subtitle = "Find the membership tier that matches your journey",
  description = "At Lightweave Beacon Legacy, membership isn’t just about access...",
  showCompareButton = true,
  limit = null, // 👈 NEW PROP
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [tiers, setTiers] = useState([]);

  // Fetch membership tiers from API
  const fetchMembershipCards = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch("/api/membership/fetch");
      const data = await response.json();

      if (data.success && Array.isArray(data.data)) {
        const HIDDEN_KEYS = ["visitor", "admin", "guest"];
        const visible = data.data
          .filter(
            (t) =>
              t.isActive !== false &&
              !HIDDEN_KEYS.includes(t.key?.toLowerCase())
          )
          .reverse();
        setTiers(visible);
      } else {
        setTiers([]);
      }
    } catch (error) {
      console.error("Error fetching membership tiers:", error);
      setTiers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMembershipCards();
  }, [fetchMembershipCards]);

  return (
    <section className="circle py-[60px] px-[1rem] w-[100%]">
      <div className="m-auto ">
        <h4 className="text-[#000] font-outfit text-sm md:text-base">
          {subtitle}
        </h4>

        <h2 className="text-[#000] font-cinzel text-[40px] lg:text-[80px]">
          {heading}
        </h2>

        <p className="text-[#000] mb-10 font-outfit text-sm md:text-base">
          {description}
        </p>

        {/* Loader */}
        {loading && (
          <p className="text-center mt-10  font-outfit">
            Loading membership plans...
          </p>
        )}

        {/* If no data found */}
        {!loading && tiers.length === 0 && (
          <p className="text-center mt-10 font-outfit text-red-500">
            No membership tiers available.
          </p>
        )}

        {/* <Row gutter={[24, 24]} className="mt-5">
          {(limit ? tiers.slice(0, limit) : tiers).map((tier, index) => {
            // First 3 cards: md={8} (3 per row)
            // Remaining cards: md={8} but centered with offset
            const colSpan = 8;
            const offset = index >= 3 && (index - 3) % 2 === 0 ? 4 : 0;

            return (
              <Col xs={24} sm={24} md={colSpan} offset={offset} key={tier._id}>
                <div
                  className="group relative w-full h-full rounded-2xl p-5 
                    transition-all duration-500 hover:scale-[1.04] 
                    hover:-translate-y-2 hover:shadow-xl"
                  style={{
                    background:
                      "linear-gradient(29deg, rgba(0, 240, 251, 1) 0%, rgba(255,255,255,1) 50%, rgba(0, 240, 251, 1) 100%)",
                  }}
                >
                  <h2
                    className="font-cinzel text-[25px] pt-2 pb-2 font-medium 
                      transition-all duration-500 group-hover:tracking-wide"
                  >
                    {tier.title}
                  </h2>

                  <ul>
                    {tier.points.map((point, idx) => (
                      <li
                        key={idx}
                        className="font-outfit mt-3 transition-all duration-500 group-hover:translate-x-1"
                      >
                        {point}
                      </li>
                    ))}
                  </ul>

                  <button
                    onClick={() =>
                      navigate("/register", {
                        state: {
                          id: tier._id,
                          key: tier.key,
                          title: tier.title,
                          points: tier.points,
                          monthlyPrice: tier.monthlyPrice,
                        },
                      })
                    }
                    className="bg-black text-white font-outfit mt-5 p-3 rounded-3xl 
                      transition-all duration-500 group-hover:bg-[#222] 
                      group-hover:shadow-lg group-hover:scale-105"
                  >
                    Sign Up
                  </button>
                </div>
              </Col>
            );
          })}
        </Row> */}
    <Row gutter={[24, 24]} justify={'center'} className="mt-5 px-[1rem]">
  {(limit ? tiers.slice(0, limit) : tiers).map((tier, index) => {
    let offset = 0;
    if (index >= 3 && index % 2 === 0) {
      offset = 1;
    }

    return (
      <Col key={tier._id} xs={24} sm={12} md={8} offset={offset}>
        <div
          className="group relative w-full h-full rounded-2xl p-5 flex flex-col
            transition-all duration-500 hover:scale-[1.04]
            hover:-translate-y-2 hover:shadow-xl"
          style={{
            background:
              "linear-gradient(29deg, rgba(0, 240, 251, 1) 0%, rgba(255,255,255,1) 50%, rgba(0, 240, 251, 1) 100%)",
          }}
        >
          {/* Price badge */}
          <div className="flex items-center justify-between mb-1">
            <h2 className="font-cinzel text-[22px] pt-2 pb-1 font-medium">
              {tier.title}
            </h2>
            <span className="font-outfit font-bold text-[18px] text-black">
              {tier.monthlyPrice > 0 ? `$${tier.monthlyPrice}/mo` : "Free"}
            </span>
          </div>

          <ul className="flex-1 mb-5">
            {tier.points.map((point, idx) => (
              <li
                key={idx}
                className="font-outfit mt-2 text-sm flex items-start gap-2"
              >
                <span className="mt-0.5 text-black font-bold flex-shrink-0">✓</span>
                {point}
              </li>
            ))}
          </ul>

          <button
            onClick={() =>
              navigate("/register", {
                state: {
                  id: tier._id,
                  key: tier.key,
                  title: tier.title,
                  points: tier.points,
                  monthlyPrice: tier.monthlyPrice,
                  yearlyPrice: tier.yearlyPrice || 0,
                },
              })
            }
            className="w-full bg-black text-white font-outfit font-semibold py-3 rounded-3xl
              transition-all duration-500 hover:bg-[#222]
              hover:shadow-lg hover:scale-105 mt-auto"
          >
            {tier.monthlyPrice > 0 ? "Get Started" : "Join Free"}
          </button>
        </div>
      </Col>
    );
  })}
</Row>


 
        {/* {showCompareButton && (
          <button
            className="mt-[45px] text-black font-outfit font-semibold px-6 py-3 rounded-full 
                       shadow-md transition-all duration-500 bg-gradient-to-r from-[#00F0FB] via-white to-[#00F0FB]
                       bg-[length:200%_200%] bg-left hover:bg-right hover:scale-105"
          >
            Compare Plans &amp; Join Today
          </button>
        )} */}
      </div>
    </section>
  );
}

export default Mention;
